import { MLink } from "@/lib/marketing/m-link";
import type { LegalLink } from "@/components/marketing/site/legal/legal-spans";

/** A link inside the contract that stays on the marketing site. */
export const siteLink: LegalLink = (text, href) => (
  <MLink href={href} className="text-primary underline underline-offset-4">
    {text}
  </MLink>
);
